import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Title({
  small = false,
  icon,
  title,
  button = null,
  actionIcon = null,
  className,
  otherAction,
}) {
  return (
    <div
      className={`${
        small ? "text-lg" : "text-2xl"
      } font-bold border-b pb-4 mb-6 flex justify-between items-center ${className}`}
    >
      <span>
        {icon && (
          <FontAwesomeIcon icon={icon} className="text-bioport-orange mr-4" />
        )}
        {title.charAt(0).toUpperCase() + title.slice(1)}
      </span>
      {button && button !== null && (
        <div className="text-sm font-normal">
          <div
            className="btn btn-primary btn-small cursor-pointer rounded hover:bg-bioport-blue-dark"
            onClick={button.fn}
          >
            {button.icon && <span className="mr-2">{button.icon}</span>}
            {button.label}
          </div>
        </div>
      )}
      {actionIcon && <div onClick={actionIcon.fn}>{actionIcon.icon}</div>}
      {otherAction && <div>{otherAction}</div>}
    </div>
  );
}

export default Title;
